import React, { useEffect, useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { getCurrentClubApprovedMembers, getAccountAvatars, getCurrentClub } from "../../../../store/selectors";
import PlayerRow from '../../../Units/RealPlayerTab';
import parameters from '../../../../config/parameters';
import { updateSelectedMembers } from '../../../../store/actionCreators/selectDownline';
import { haveSameElements } from '../../../../helpers/array';

const emptySelected = [];

const renderDownline = (avatarList, select, selected) => dl => (
    <div onClick={e =>select(e, dl._id)} key={dl._id}>
        <PlayerRow
          player={dl} type={'sendVip'}
          avatar={avatarList[dl._id]}
          selected={selected.indexOf(dl._id) > -1}
        />
    </div>
);

const SelectDownline = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { memberId } = useParams();
    const agentId = parseInt(memberId, 10);
    const memberList = useSelector(getCurrentClubApprovedMembers);
    const agent = useMemo(() => memberList.find(m => m._id === agentId), [memberList, agentId]);

    const [search, setSearch] = useState('');
    const currentClub = useSelector(getCurrentClub);

    const downlines = useMemo(() => memberList.filter(
        m => (
            currentClub.playerAccount.id !== m._id &&
            parseInt(m.typeId, 10) !== parameters.accountTypes.manager &&
            parseInt(m.typeId, 10) !== parameters.accountTypes.agent && (
                m.parentId === agent.roleAccountId ||
                m.parentId === m.skinId
            ) && (
                !search ||
                m.username.indexOf(search) !== -1
            )
        )
    ), [memberList, parameters, agent, search]);
    const avatarList = useSelector(getAccountAvatars);
    const [selected, setSelected] = useState(emptySelected);
    const [originalSelected, setOriginalSelected] = useState(emptySelected);

    useEffect(() => {
      const newSelected = downlines.filter(m => m.parentId === agent.roleAccountId).map(m => m._id);
      setSelected(newSelected);
      setOriginalSelected(newSelected);
    }, []);

    const onChangeSearch = useCallback(e => {
        setSearch(e.target.value);
    }, []);

    const onSelect = useCallback((e, playerId) => {
        if (e.target.type === 'checkbox') {
            if (!selected.find(id => id === playerId)) {
                setSelected([...selected, playerId]);
            } else {
                setSelected(selected.filter(id => id !== playerId));
            }
        }
    }, [selected]);

    const isConfirmDisabled = useMemo(
        () => haveSameElements(selected, originalSelected),
        [selected, originalSelected],
    );

    const onConfirm = useCallback(() => {
        dispatch(updateSelectedMembers(agent.roleAccountId, selected));
    }, [agent, selected]);

    return (
        <React.Fragment>
            <p className={`selectDownlineText`}>{t('selectDownlineText')}</p>
            <div className={`searchMember`}>
                <input onChange={onChangeSearch} />
                <span className={'searchIcon'}></span>
            </div>
            <div className={`memberList selectDownline`}>
                { downlines.map(renderDownline(avatarList, onSelect, selected))}
            </div>
            <div className={`dialogConfirmBox`}>
                <button className="primary" disabled={isConfirmDisabled} onClick={onConfirm}>
                    {t('button.confirm')}
                </button>
            </div>
        </React.Fragment>
    );
};

export default SelectDownline ;
